var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"note-disclaimer"},[_c('span',{staticClass:"fa-bg"},[_c('i',{staticClass:"fa fa-exclamation"})]),_vm._v(" If you take a generic medication, list the generic name, not the brand name. This helps ensure accurate review of your prescriptions. ")])])
}]

export { render, staticRenderFns }